module.exports = __webpack_public_path__ + "static/media/16UNODC21.2c990adf.jpg";